var _style, _g, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _g2, _path3, _path4, _path5, _g3, _rect6, _g4, _rect7, _path6, _path7, _rect8, _rect9, _rect10, _rect11, _g5, _path8, _path9, _g6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinervaLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#474B4F;}\r\n\t.st1{fill:#7AC143;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#474B4F;}\r\n\t.st3{fill:#70C143;}\r\n\t.st4{fill:url(#SVGID_1_);}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st7{fill:url(#SVGID_00000002377513304449190510000008329881971412118145_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "249.02,1030.25 315.56,1030.25 483.86,427.13 517.12,546.35 382.1,1030.25 448.63,1030.25  550.39,665.57 550.39,665.57 652.15,1030.25 718.69,1030.25 503.43,258.81 464.29,258.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1035.71,258.81 996.57,258.81 816.54,904.02 750,665.57 863.5,258.81 796.97,258.81 716.73,546.35  636.5,258.81 569.96,258.81 785.23,1030.25 847.85,1030.25 916.34,784.79 984.83,1030.25 1051.37,1030.25 949.61,665.57  1016.14,427.13 1184.44,1030.25 1250.98,1030.25  "
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 339.07,
    y: 1100.38,
    className: "st2",
    width: 20.55,
    height: 140.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.14,1240.27v-74.31l19.87-19.79v94.1H278.14z M169.93,1153.71v86.94h-18.75v-140.26l73.35,72.34 l73.35-72.34l0,30.66l-73.34,73.24L169.93,1153.71z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.22,1240.27v-94.1l20.55,24.07v70.03H398.22z M398.22,1131.04l0-30.66l98.77,116.86l0-116.86h20.95 v140.26h-25.67L398.22,1131.04z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 555.47,
    y: 1100.38,
    className: "st0",
    width: 20.55,
    height: 140.26
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 586.83,
    y: 1100.38,
    className: "st0",
    width: 63.09,
    height: 21.17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 586.83,
    y: 1161.24,
    className: "st0",
    width: 63.09,
    height: 20.79
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 586.83,
    y: 1219.48,
    className: "st0",
    width: 63.09,
    height: 21.16
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1186.07,1130c7.71,0,14.96,1.46,21.75,4.37c6.79,2.91,12.7,6.88,17.72,11.9 c5.02,5.02,8.97,10.92,11.86,17.7c2.89,6.78,4.33,14.04,4.33,21.77c0,7.63-1.44,14.82-4.33,21.54 c-2.89,6.73-6.84,12.61-11.86,17.63c-5.02,5.02-10.93,8.99-17.72,11.9c-6.8,2.91-14.04,4.37-21.75,4.37 c-7.71,0-14.93-1.46-21.68-4.37c-6.74-2.91-12.62-6.88-17.64-11.9c-5.02-5.02-8.98-10.9-11.86-17.63 c-2.89-6.73-4.34-13.91-4.34-21.54c0-7.73,1.45-14.99,4.34-21.77c2.89-6.78,6.85-12.68,11.86-17.7 c5.02-5.02,10.9-8.99,17.64-11.9C1171.14,1131.45,1178.36,1130,1186.07,1130z M1186.07,1225.67c5.27,0,10.27-1.05,14.98-3.15 c4.71-2.1,8.82-4.95,12.32-8.56c3.5-3.6,6.26-7.83,8.29-12.68c2.03-4.85,3.04-10.03,3.04-15.53c0-5.5-1.01-10.71-3.04-15.61 c-2.03-4.9-4.79-9.18-8.29-12.83c-3.5-3.65-7.61-6.53-12.32-8.63c-4.71-2.1-9.71-3.15-14.98-3.15s-10.24,1.05-14.91,3.15 c-4.66,2.1-8.74,4.98-12.24,8.63c-3.5,3.65-6.26,7.93-8.29,12.83c-2.03,4.9-3.04,10.11-3.04,15.61c0,5.5,1.01,10.68,3.04,15.53 c2.03,4.85,4.79,9.08,8.29,12.68c3.5,3.6,7.58,6.45,12.24,8.56C1175.83,1224.62,1180.79,1225.67,1186.07,1225.67z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1281.63,
    y: 1100.38,
    className: "st3",
    width: 21.23,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.98,
    y: 1100.38,
    className: "st3",
    width: 21.23,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.68,
    y: 1100.38,
    className: "st3",
    width: 36.84,
    height: 19.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1311.99,
    y: 1100.38,
    className: "st3",
    width: 36.84,
    height: 19.34
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.46,1100.38v140.07h-20.55v-140.07H711.46z M795.42,1240.64h-26.54l-46.9-60.78h21.98 c4.23,0,32.5-1.05,32.5-29.35c0-25.68-23.21-30.8-32.5-30.8h-21.98v-19.34h19.49c11.52,0,53.19,4.77,53.19,49.95 c0,33.32-29.01,46.53-34.18,46.53L795.42,1240.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 932.9371,
    y1: 1170.5125,
    x2: 1055.775,
    y2: 1170.5125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#474B4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5919,
    style: {
      stopColor: "#5F8F48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70C143"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M994.34,1100.38l61.44,140.26h-22.87l-38.55-85.23l-38.55,85.23h-22.87L994.34,1100.38z M1004.39,1219.29 h-19.87v21.35h19.87V1219.29z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M877.22,1240.64l-61.44-140.26h22.87l38.55,85.23l38.55-85.23h22.87L877.22,1240.64z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1241.68,266.44h-21.14v-7.63H1272v7.63h-21.24v61.87h-9.08V266.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.3,297.79c-0.52-9.69-1.13-21.35-1.03-30.01h-0.31c-2.37,8.15-5.26,16.81-8.77,26.4l-12.27,33.72h-6.81l-11.24-33.1 c-3.3-9.8-6.08-18.77-8.04-27.02h-0.21c-0.21,8.66-0.72,20.32-1.34,30.73l-1.86,29.8h-8.56l4.85-69.5h11.45l11.86,33.62 c2.89,8.56,5.26,16.19,7.01,23.41h0.31c1.75-7.01,4.23-14.64,7.32-23.41l12.37-33.62h11.45l4.33,69.5h-8.77L1338.3,297.79z"
  })))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1851,
    y: 0,
    width: 1500,
    height: 1500
  })), /*#__PURE__*/React.createElement("g", null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "2100.02,1030.25 2166.56,1030.25 2334.85,427.13 2368.12,546.35 2233.09,1030.25 2299.63,1030.25  2401.39,665.57 2401.39,665.57 2503.15,1030.25 2569.69,1030.25 2354.42,258.81 2315.28,258.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2886.71,258.81 2847.57,258.81 2667.53,904.02 2601,665.57 2714.5,258.81 2647.96,258.81  2567.73,546.35 2487.49,258.81 2420.96,258.81 2636.22,1030.25 2698.84,1030.25 2767.34,784.79 2835.83,1030.25 2902.36,1030.25  2800.6,665.57 2867.14,427.13 3035.44,1030.25 3101.97,1030.25  "
  }))), /*#__PURE__*/React.createElement("g", null, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2190.06,
    y: 1100.38,
    className: "st6",
    width: 20.55,
    height: 140.26
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2129.14,1240.27v-74.31l19.87-19.79v94.1H2129.14z M2020.93,1153.71v86.94h-18.75v-140.26l73.35,72.34 l73.35-72.34l0,30.66l-73.34,73.24L2020.93,1153.71z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2249.22,1240.27v-94.1l20.55,24.07v70.03H2249.22z M2249.22,1131.04l0-30.66l98.77,116.86l0-116.86h20.95 v140.26h-25.68L2249.22,1131.04z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2406.47,
    y: 1100.38,
    className: "st5",
    width: 20.55,
    height: 140.26
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2437.83,
    y: 1100.38,
    className: "st5",
    width: 63.09,
    height: 21.17
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2437.83,
    y: 1161.24,
    className: "st5",
    width: 63.09,
    height: 20.79
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 2437.83,
    y: 1219.48,
    className: "st5",
    width: 63.09,
    height: 21.16
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3037.06,1130c7.71,0,14.96,1.46,21.75,4.37c6.79,2.91,12.7,6.88,17.72,11.9 c5.02,5.02,8.97,10.92,11.86,17.7c2.89,6.78,4.33,14.04,4.33,21.77c0,7.63-1.44,14.82-4.33,21.54 c-2.89,6.73-6.84,12.61-11.86,17.63c-5.02,5.02-10.93,8.99-17.72,11.9c-6.8,2.91-14.04,4.37-21.75,4.37s-14.93-1.46-21.68-4.37 c-6.74-2.91-12.62-6.88-17.64-11.9c-5.02-5.02-8.98-10.9-11.86-17.63c-2.89-6.73-4.34-13.91-4.34-21.54 c0-7.73,1.45-14.99,4.34-21.77c2.89-6.78,6.85-12.68,11.86-17.7c5.02-5.02,10.9-8.99,17.64-11.9 C3022.13,1131.45,3029.36,1130,3037.06,1130z M3037.06,1225.67c5.27,0,10.27-1.05,14.98-3.15c4.71-2.1,8.82-4.95,12.32-8.56 c3.5-3.6,6.26-7.83,8.29-12.68c2.03-4.85,3.04-10.03,3.04-15.53c0-5.5-1.01-10.71-3.04-15.61c-2.03-4.9-4.79-9.18-8.29-12.83 c-3.5-3.65-7.61-6.53-12.32-8.63c-4.71-2.1-9.71-3.15-14.98-3.15c-5.27,0-10.24,1.05-14.91,3.15c-4.66,2.1-8.75,4.98-12.24,8.63 c-3.5,3.65-6.26,7.93-8.29,12.83c-2.03,4.9-3.04,10.11-3.04,15.61c0,5.5,1.01,10.68,3.04,15.53c2.03,4.85,4.79,9.08,8.29,12.68 c3.5,3.6,7.58,6.45,12.24,8.56C3026.82,1224.62,3031.79,1225.67,3037.06,1225.67z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3132.63,
    y: 1100.38,
    className: "st3",
    width: 21.23,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2929.97,
    y: 1100.38,
    className: "st3",
    width: 21.23,
    height: 140.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3086.67,
    y: 1100.38,
    className: "st3",
    width: 36.84,
    height: 19.34
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3162.98,
    y: 1100.38,
    className: "st3",
    width: 36.84,
    height: 19.34
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2562.46,1100.38v140.07h-20.55v-140.07H2562.46z M2646.41,1240.64h-26.54l-46.9-60.78h21.98 c4.23,0,32.5-1.05,32.5-29.35c0-25.68-23.21-30.8-32.5-30.8h-21.98v-19.34h19.49c11.52,0,53.19,4.77,53.19,49.95 c0,33.32-29.01,46.53-34.18,46.53L2646.41,1240.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176732852885181962110000000369873522476580766_",
    gradientUnits: "userSpaceOnUse",
    x1: 2783.9333,
    y1: 1170.5125,
    x2: 2906.7712,
    y2: 1170.5125
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3823,
    style: {
      stopColor: "#CAE8BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70C143"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176732852885181962110000000369873522476580766_)"
    },
    d: "M2845.33,1100.38l61.44,140.26h-22.87 l-38.55-85.23l-38.55,85.23h-22.87L2845.33,1100.38z M2855.39,1219.29h-19.87v21.35h19.87V1219.29z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2728.22,1240.64l-61.44-140.26h22.87l38.55,85.23l38.55-85.23h22.87L2728.22,1240.64z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3092.68,266.44h-21.14v-7.63H3123v7.63h-21.24v61.87h-9.08V266.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3189.3,297.79c-0.52-9.69-1.13-21.35-1.03-30.01h-0.31c-2.37,8.15-5.26,16.81-8.77,26.4l-12.27,33.72h-6.81 l-11.24-33.1c-3.3-9.8-6.08-18.77-8.04-27.02h-0.21c-0.21,8.66-0.72,20.32-1.34,30.73l-1.86,29.8h-8.56l4.85-69.5h11.45 l11.86,33.62c2.89,8.56,5.26,16.19,7.01,23.41h0.31c1.75-7.01,4.23-14.64,7.32-23.41l12.37-33.62h11.45l4.33,69.5h-8.77 L3189.3,297.79z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaLogoColor);
export default __webpack_public_path__ + "static/media/Minerva_LogoColor.73a7f8601554bb4d4aaba5fd1164761d.svg";
export { ForwardRef as ReactComponent };